import { Component, Input, OnInit } from '@angular/core';
import { LocalStorageService } from '../_services/local-storage.service';
import { PersonSearchService } from '../_services/person-search.service';
import * as _ from 'underscore';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-jdinsights-modal',
    templateUrl: './jdinsights-modal.component.html',
    styleUrls: ['./jdinsights-modal.component.scss'],
    standalone: false
})
export class JdinsightsModalComponent implements OnInit {

  @Input() candidateElasticId;
  @Input() candidateName;
  jdInsightsResponse: any;
  overallExplanationAlignment: string;
  overallExplanationdivergence: string;
  commonArray: any[] = [];
  gapArray: any[] = [];
  comparisonKeys: any[] = [];
  maxScoreArray: any[] = [];
  minScoreArray: any[] = [];
  showLoaderbeforeDataLoad: Boolean = false;
  showAll: Boolean = false;
  @Input() parsedJDKeys: any;


  constructor(private localStorageService: LocalStorageService, private personSearchService: PersonSearchService, private modalService: NgbModal) { }

  ngOnInit() {
    this.getJdInsights();
  }

  getJdInsights() {
    this.showLoaderbeforeDataLoad = true;
    const payload = {
      elasticid: this.candidateElasticId,
      jdsearchhistoryid: this.localStorageService.getItem('jdinsightshistoryid')
    }
    if(!payload.jdsearchhistoryid) {
      payload['parsed_jd'] = this.parsedJDKeys;

    }
    this.personSearchService.getJdInsights(payload).subscribe(response => {
      this.showLoaderbeforeDataLoad = false;
      if(response && response.status === 'success') {
        this.jdInsightsResponse = response.data;
        this.overallExplanationAlignment = this.jdInsightsResponse.overall_explanation.alignment;
        this.overallExplanationdivergence = this.jdInsightsResponse.overall_explanation.divergence;
         this.commonArray = Object.keys(this.jdInsightsResponse).filter(key => this.jdInsightsResponse[key]?.score >= 4).map(key => ({ key, ...this.jdInsightsResponse[key] }));
        this.gapArray = Object.keys(this.jdInsightsResponse).filter(key => this.jdInsightsResponse[key]?.score == 0 || this.jdInsightsResponse[key]?.score < 4).map(key => ({ key, ...this.jdInsightsResponse[key] }));
        this.comparisonKeys = Object.keys(this.jdInsightsResponse).filter(key => typeof this.jdInsightsResponse[key] === 'object' && key !== 'overall_explanation');
        this.maxScoreArray = this.commonArray.filter(x => x.score >= 7);
        this.minScoreArray = this.commonArray.filter(x => (x.score >= 4 && x.score < 7));
        this.commonArray = _.sortBy(this.commonArray, "score").reverse();
      }
    });
  }

formattedText(text) {
  return text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
}

  closeModal() {
    this.modalService.dismissAll();
  }

    showMore() {
    this.showAll = true;
  }

  showLess() {
    this.showAll = false;
  }

}
